module.exports = __webpack_public_path__ + "img/场景.43ecb1ca.png";